import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            海量内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大内容品类，满足您对各类影视娱乐内容的需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-white">{cat.name}</h3>
                </div>
                <p className="text-xs text-white/70 line-clamp-2">{cat.description}</p>
                <span className="inline-block mt-2 text-xs text-primary-300">
                  {cat.count.toLocaleString()} 部资源
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}